import { Form, Input, Button } from "semantic-ui-react";
import useApiDiretorio from "../../hooks/useApiDiretorio";
import CidadeSelect from "./components/CidadeSelect";
import useForm from "../../hooks/useForm";
import MessageErrorsValidation from "../../components/MessageErrorsValidation";
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input/mobile";
import ptBR from "react-phone-number-input/locale/pt-BR";
import { useNavigate } from 'react-router-dom';

function StepInicio({ dadosPedido, setDadosPedido, nextStep }) {
  const { data: estados } = useApiDiretorio("/unidade-federativa");
  const navigate = useNavigate();

  const nextWithValidation = () => {
    let phone = parsePhoneNumber(data.celular);

    setDadosPedido({
      ...dadosPedido,
      nomeSocial: data.nomeSocial,
      nomeRegistro: data.nomeSocial,
      ddi1: phone.countryCallingCode,
      celular1: phone.nationalNumber,
      celular: data.celular,
      email: data.email,
      ufFiliacao: data.ufFiliacao,
      municipioFiliacao: data.municipioFiliacao,
      zonal: data.zonal,
    });
    nextStep();
  };

  const validations = {
    nomeSocial: {
      required: {
        value: true,
        message: "Informe seu nome completo",
      },
      custom: {
        isValid: (value) => /^[a-zA-ZáéíóúÁÉÍÓÚâêîôûÂÊÎÔÛãõñçÇ ]+$/.test(value),
        message: "Nome deve conter apenas letras",
      },
    },
    celular: {
      required: {
        value: true,
        message: "Informe seu celular",
      },
      custom: {
        isValid: (value) => value && isValidPhoneNumber(value),
        message: "Informe um celular válido",
      },
    },
    email: {
      required: {
        value: true,
        message: "Informe seu e-mail",
      },
      pattern: {
        value: /^([a-z0-9+_-]+)(\.[a-z0-9+_-]+)*@([a-z0-9-]+\.)+[a-z]{2,6}$/i,
        message: "Informe um e-mail válido",
      },
    },
    ufFiliacao: {
      required: {
        value: true,
        message: "Informe seu estado de moradia",
      },
    },
    municipioFiliacao: {
      required: {
        value: true,
        message: "Informe sua cidade de moradia",
      },
    },
  };

  const { data, handleChange, handleSubmit, handleBlur, errors } = useForm(
    validations,
    dadosPedido,
    nextWithValidation
  );


  const getOptionsEstado = () => {
    let options = [];

    options = estados.map((s) => ({
      key: s.codigo,
      value: s.codigo,
      text: s.codigo,
    }));

    options.unshift({key: -1});

    return options;
  };

  const irParaAcompanharPedido = () => {
    navigate('/acompanhar-pedido');
  }

  return (
    <>
      <Form.Group widths="equal">
        <Form.Field
          id="nomeSocial"
          name="nomeSocial"
          control={Input}
          required
          defaultValue={data.nomeSocial}
          label="Nome"
          onBlur={handleBlur}
          error={!!errors.nomeSocial}
          onChange={(e, data) => handleChange("nomeSocial", data.value)}
          maxLength={100}
        />
      </Form.Group>
      <Form.Group>
        <Form.Select
          fluid
          search
          required
          label="Estado"
          name="ufFiliacao"
          value={data.ufFiliacao}
          options={getOptionsEstado()}
          error={!!errors.ufFiliacao}
          onChange={(e, data) => handleChange("ufFiliacao", data.value)}
          onBlur={handleBlur}
          width={4}
        />
        <CidadeSelect
          onChange={(field, value) => handleChange(field, value)}
          onBlur={handleBlur}
          error={!!errors.municipioFiliacao }
          estado={data.ufFiliacao}
          value={data.municipioFiliacao}
        />
      </Form.Group>
      {data.zonal ? (
        <button
          type="button"
          style={{
            textDecoration: "underline",
            paddingLeft: "110px",
            color: "#333",
            border: "none",
          }}
        >
          Zonal: {data.zonal.nomeZonal}
        </button>
      ) : null}
      <Form.Group widths="equal">
        <Form.Input fluid label="Whatsapp" required error={!!errors.celular}>
          <PhoneInput
            defaultCountry="BR"
            labels={ptBR}
            value={data.celular}
            onChange={(e) => handleChange("celular", e)}
          />
        </Form.Input>
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Input
          fluid
          required
          name="email"
          label="E-mail"
          defaultValue={data.email}
          type="email"
          onBlur={handleBlur}
          error={!!errors.email}
          width={10}
          maxLength={100}
          onChange={(e, data) => handleChange("email", data.value)}
        />
      </Form.Group>
      <MessageErrorsValidation errors={errors} />
      <Button className="buttonAcao" onClick={handleSubmit} primary>
        Eu quero me filiar ao PT
      </Button>
      <p>
        Ao clicar eu concordo com o{" "}
        <a
          target="_blank"
          className="linkTexto"
          rel="noreferrer"
          href="https://pt.org.br/wp-content/uploads/2018/03/estatuto-pt-2012-versao-final-alterada-junho-2017.pdf"
        >
          Estatuto do PT
        </a>{" "}
        e a{" "}
        <a
          target="_blank"
          className="linkTexto"
          rel="noreferrer"
          href="https://pt.org.br/politica-de-privacidade/"
        >
          Política de Privacidade
        </a>
      </p>
      <p style={{ textAlign: "center" }}>
        <Button className="btn-link" type="button" onClick={irParaAcompanharPedido}>
          Quero saber se meu pedido de filiação foi aprovado.
        </Button>
      </p>
    </>
  );
}

export default StepInicio;
